// extracted by mini-css-extract-plugin
export default {"row":"ProlongationForm_row__6+21Z","form":"ProlongationForm_form__mnZuE","footer":"ProlongationForm_footer__SbETe","button":"ProlongationForm_button__lo4Lu"};